




































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  InputDependency,
  TemplateInput,
  InputHeader,
  INPUT_TYPES
} from "@/store/template/types";

@Component
export default class ColumnTile extends Vue {
  @Prop() input!: TemplateInput;
  @Prop() index!: number;
  @Prop() header!: InputHeader;

  get type() {
    let _type = INPUT_TYPES.find(item => {
      return item.value == this.header.type;
    });
    return _type ? _type.label : "";
  }

  remove() {
    this.input.headers.splice(this.index, 1);
  }
}
